var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9994 29.5V34.1667M32.9994 38.8334H33.0111M31.3839 23.5404L21.7882 40.1148C21.256 41.0341 20.9899 41.4937 21.0292 41.871C21.0635 42.2001 21.2359 42.4991 21.5035 42.6936C21.8103 42.9167 22.3414 42.9167 23.4037 42.9167H42.5951C43.6574 42.9167 44.1885 42.9167 44.4953 42.6936C44.7629 42.4991 44.9353 42.2001 44.9696 41.871C45.0089 41.4937 44.7428 41.0341 44.2105 40.1148L34.6148 23.5404C34.0845 22.6243 33.8194 22.1663 33.4734 22.0125C33.1716 21.8783 32.8271 21.8783 32.5254 22.0125C32.1794 22.1663 31.9143 22.6243 31.3839 23.5404Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alertTriangle.96606e6503633bf62845947bebe5c26b.svg";
export { ForwardRef as ReactComponent };